import React from "react"
import { StaticQuery, graphql, Link } from "gatsby"
import footerStyles from "./footer.module.scss"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Bandeau from "./../bandeau/bandeau.module"

export default ({ data }) => (
  <StaticQuery
    query={graphql`
      query {
        site {
          siteMetadata {
            websiteConfig {
              contact {
                address {
                  icon
                  content
                }
                phone {
                  icon
                  content
                }
                faxe {
                  icon
                  content
                }
                email {
                  icon
                  content
                }
                copyright {
                  owner
                  signature
                }
              }
            }
          }
        }
      }
    `}
    render={data => (
      <div className="row">
        <div className="col-lg-12 p-0">
          <div className="container-fluid">
            <Bandeau
              title="Liste des avantages de nos clients"
              link_texte="demandez un devis gratuit"
              link_route="devis"
            />
            <div className="row pt-4 pb-4 p-1">
              <div className="col-lg-3 line-height-2">
                <p className="pt-3">
                  Première plateforme de publicité mobile Algérienne.
                </p>
                <div>
                  <FontAwesomeIcon
                    className={footerStyles.svg}
                    icon="facebook-square"
                  />
                  <FontAwesomeIcon
                    className={footerStyles.svg}
                    icon="linkedin"
                  />
                  <FontAwesomeIcon
                    className={footerStyles.svg}
                    icon="twitter-square"
                  />
                </div>
              </div>

              <div className="col-lg-3 line-height-2">
                <strong>Liens</strong>
                <ul className="pt-1">
                  <li>Diffusez vos annonces</li>
                  <li>Réseau de tablette</li>
                  <li>Vous êtes taxieur</li>
                </ul>
              </div>
              <div className="col-lg-3 line-heigh-2">
                <strong>Contact</strong>
                <div className="pt-1">
                  <FontAwesomeIcon
                    className={footerStyles.svg}
                    icon={[
                      "fas",
                      data.site.siteMetadata.websiteConfig.contact.address.icon,
                    ]}
                  />
                  {data.site.siteMetadata.websiteConfig.contact.address.content}
                </div>
                <div className="pt-1">
                  <FontAwesomeIcon
                    className={footerStyles.svg}
                    icon={
                      data.site.siteMetadata.websiteConfig.contact.phone.icon
                    }
                  />
                  {data.site.siteMetadata.websiteConfig.contact.phone.content}
                </div>
                <div className="pt-1">
                  <FontAwesomeIcon
                    className={footerStyles.svg}
                    icon={
                      data.site.siteMetadata.websiteConfig.contact.faxe.icon
                    }
                  />
                  {data.site.siteMetadata.websiteConfig.contact.faxe.content}
                </div>
                <div className="pt-1">
                  <FontAwesomeIcon
                    className={footerStyles.svg}
                    icon={
                      data.site.siteMetadata.websiteConfig.contact.email.icon
                    }
                  />
                  {data.site.siteMetadata.websiteConfig.contact.email.content}
                </div>
              </div>
              <div className="col-lg-3 line-height-2">
                <strong>Newsletter</strong>
                <ul>
                  <li className="pt-1">Vous êtes une boite de pub</li>
                  <li className="pt-1">Demandez un devis</li>
                  <li className="pt-1">Devenir partenaire</li>
                </ul>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-lg-12">
                <p style={{ fontSize: "10px" }}>
                  © Copyright
                  <span className="ml-1 mr-1">
                    {
                      data.site.siteMetadata.websiteConfig.contact.copyright
                        .owner
                    }
                  </span>
                  . All Rights Reserved. Made By
                  <a
                    className="ml-1 mr-1"
                    href={
                      "https://" +
                      data.site.siteMetadata.websiteConfig.contact.copyright
                        .signature
                    }
                  >
                    {
                      data.site.siteMetadata.websiteConfig.contact.copyright
                        .signature
                    }
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    )}
  />
)

function listSocial(social) {
  let socials = []
  social.map(item => {
    socials.push(
      <a href={item.link} key={item.icon}>
        <FontAwesomeIcon
          className={footerStyles.socialFont}
          icon={["fab", item.icon]}
        />
      </a>
    )
  })

  return <ul className={`${footerStyles.socialList} m-0`}>{socials}</ul>
}
